"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    background: theme.palette.background.footer.bar,
    bottom: 0,
    left: 0,
    position: "fixed",
    right: 0,
    zIndex: theme.zIndex.overlay
  },
  buttonWrapper: {
    alignItems: "center",
    height: "calc(env(safe-area-inset-bottom) + 75px)",
    paddingBottom: "env(safe-area-inset-bottom)"
  },
  buttonReset: {
    "& button": {
      color: theme.palette.common.white,
      fontWeight: 600,
      paddingLeft: 0,
      paddingRight: 0,
      textTransform: "none"
    }
  },
  buttonFilter: {
    display: "flex",
    justifyContent: "flex-end"
  }
}));
const FilterButtonGroup = props => {
  const {
    labelConfirm,
    labelReset,
    onConfirm,
    onReset
  } = props;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.root
  }, /*#__PURE__*/_react.default.createElement(_core.Container, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.buttonWrapper,
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.buttonReset,
    item: true,
    xs: 5
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disableRipple: true,
    onClick: onReset
  }, labelReset)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.buttonFilter,
    item: true,
    xs: 7
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: onConfirm
  }, labelConfirm)))));
};
var _default = exports.default = FilterButtonGroup;